import { render } from "./NodeNotReleasedForm.vue?vue&type=template&id=18190c9d&scoped=true"
import script from "./NodeNotReleasedForm.vue?vue&type=script&lang=js"
export * from "./NodeNotReleasedForm.vue?vue&type=script&lang=js"

import "./NodeNotReleasedForm.vue?vue&type=style&index=0&id=18190c9d&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18190c9d"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
